import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
const SuccessStories = () => {
  const testimonials = [{
    name: 'Marina S.',
    age: 29,
    location: 'Ciudad de México',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Después de 3 meses sin contacto, apliqué el método y él volvió en 16 días. ¡Lo más increíble es que ahora está más atento que nunca durante nuestros 2 años de relación!',
    rating: 5,
    type: 'Cazador',
    days: 16
  }, {
    name: 'Juliana M.',
    age: 34,
    location: 'Bogotá',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Él terminó conmigo para estar con otra. Usé los disparadores de valor y escasez por 21 días, y no solo volvió sino que terminó con la otra diciendo que no podía olvidarme.',
    rating: 5,
    type: 'Conquistador',
    days: 21
  }, {
    name: 'Carla F.',
    age: 27,
    location: 'Lima',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Estaba desesperada cuando me bloqueó en todo. Seguí el protocolo de emergencia nivel 3 y, después de 30 días de silencio, envié el mensaje de cierre emocional. ¡Me buscó el mismo día!',
    rating: 5,
    type: 'Protector',
    days: 31
  }, {
    name: 'Patricia A.',
    age: 32,
    location: 'Santiago',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Mi caso era complicado: 5 años de relación, vivíamos juntos y dijo que ya no me amaba. Usé los disparadores de nostalgia y vulnerabilidad. ¡Hoy estamos comprometidos!',
    rating: 5,
    type: 'Protector',
    days: 19
  }, {
    name: 'Fernanda L.',
    age: 25,
    location: 'Buenos Aires',
    image: 'https://images.unsplash.com/photo-1491349174775-aaafddd81942?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Él era un crush que nunca me había notado realmente. Apliqué los disparadores de misterio y valor, y en 14 días me invitó a salir. ¡Hoy cumplimos 6 meses juntos!',
    rating: 4,
    type: 'Cazador',
    days: 14
  }, {
    name: 'Amanda R.',
    age: 30,
    location: 'Medellín',
    image: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    quote: 'Después de una ruptura traumática, pensé que nunca más hablaríamos. El test de diagnóstico me dio 85% de probabilidad y, aunque insegura, seguí el método. Volvió en 18 días suplicando por otra oportunidad.',
    rating: 5,
    type: 'Conquistador',
    days: 18
  }];
  const beforeAfterStories = [{
    name: 'Débora, 28 años',
    image: 'https://images.unsplash.com/photo-1614644147798-f8c0fc9da7f6?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    before: 'Él me bloqueó en todas las redes sociales después de una pelea. Intenté de todo: mensajes largos, regalos, hasta aparecer en su casa.',
    after: 'Apliqué el protocolo de emergencia nivel 3 y los disparadores de valor. Después de 25 días, me desbloqueó y pidió hablar. Hoy estamos juntos y dice que nunca sintió algo tan fuerte.',
    type: 'Protector',
    days: 25
  }, {
    name: 'Renata, 33 años',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    before: 'Después de 6 años juntos, dijo que necesitaba tiempo para pensar. Quedé destrozada y comencé a llamar y enviar mensajes todos los días.',
    after: 'El test me clasificó con 70% de probabilidad. Usé los disparadores de nostalgia y gratitud. En el día 19, me invitó a cenar y dijo que se dio cuenta que no podía imaginar su vida sin mí.',
    type: 'Conquistador',
    days: 19
  }, {
    name: 'Luciana, 26 años',
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    before: 'Él comenzó a alejarse sin explicación. Dejó de responder mensajes y cuando respondía era siempre frío y distante.',
    after: 'Identifiqué que era un Cazador y apliqué los disparadores de escasez y misterio. En el día 12 ya me estaba bombardeando de mensajes. Hoy soy yo quien controla el ritmo de la relación.',
    type: 'Cazador',
    days: 12
  }];
  return <div className="max-w-4xl mx-auto" data-id="element-1131">
      <header className="mb-8 text-center" data-id="element-1132">
        <h1 className="text-3xl font-bold text-[#2C2C2C] mb-2" data-id="element-1133">
          Casos de Éxito
        </h1>
        <p className="text-gray-600" data-id="element-1134">
          Historias reales de mujeres que usaron el método
        </p>
      </header>
      <div className="bg-white rounded-xl shadow-md p-6 mb-8" data-id="element-1135">
        <h2 className="text-xl font-semibold text-[#2C2C2C] mb-6" data-id="element-1136">
          Testimonios
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1137">
          {testimonials.map((testimonial, index) => <div key={index} className="border rounded-lg p-5" data-id="element-1138">
              <div className="flex items-center mb-4" data-id="element-1139">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-3" data-id="element-1140" />
                <div data-id="element-1141">
                  <h3 className="font-bold" data-id="element-1142">
                    {testimonial.name}, {testimonial.age}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1143">
                    {testimonial.location}
                  </p>
                </div>
              </div>
              <div className="mb-4 relative" data-id="element-1144">
                <QuoteIcon size={20} className="text-gray-300 absolute top-0 left-0" data-id="element-1145" />
                <p className="text-gray-700 pl-7" data-id="element-1146">{testimonial.quote}</p>
              </div>
              <div className="flex justify-between items-center" data-id="element-1147">
                <div className="flex" data-id="element-1148">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className={i < testimonial.rating ? 'text-[#FFD700] fill-[#FFD700]' : 'text-gray-300'} data-id="element-1149" />)}
                </div>
                <div className="flex space-x-2 text-sm" data-id="element-1150">
                  <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full" data-id="element-1151">
                    {testimonial.type}
                  </span>
                  <span className="bg-pink-100 text-pink-700 px-2 py-1 rounded-full" data-id="element-1152">
                    {testimonial.days} días
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6 mb-8" data-id="element-1153">
        <h2 className="text-xl font-semibold text-[#2C2C2C] mb-6" data-id="element-1154">
          Antes y Después
        </h2>
        <div className="space-y-6" data-id="element-1155">
          {beforeAfterStories.map((story, index) => <div key={index} className="border rounded-lg overflow-hidden" data-id="element-1156">
              <div className="flex items-center p-4 border-b" data-id="element-1157">
                <img src={story.image} alt={story.name} className="w-12 h-12 rounded-full object-cover mr-3" data-id="element-1158" />
                <div data-id="element-1159">
                  <h3 className="font-bold" data-id="element-1160">{story.name}</h3>
                  <div className="flex space-x-2 text-sm" data-id="element-1161">
                    <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full" data-id="element-1162">
                      {story.type}
                    </span>
                    <span className="bg-pink-100 text-pink-700 px-2 py-1 rounded-full" data-id="element-1163">
                      {story.days} días
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-1164">
                <div className="p-4 bg-gray-50" data-id="element-1165">
                  <h4 className="font-medium text-red-500 mb-2" data-id="element-1166">Antes:</h4>
                  <p className="text-gray-700" data-id="element-1167">{story.before}</p>
                </div>
                <div className="p-4 bg-green-50" data-id="element-1168">
                  <h4 className="font-medium text-green-600 mb-2" data-id="element-1169">Después:</h4>
                  <p className="text-gray-700" data-id="element-1170">{story.after}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-1171">
        <div className="text-center mb-6" data-id="element-1172">
          <h2 className="text-xl font-semibold text-[#2C2C2C] mb-2" data-id="element-1173">
            Tasa de Éxito Comprobada
          </h2>
          <div className="text-5xl font-bold text-[#E91E63]" data-id="element-1174">90.5%</div>
          <p className="text-gray-600 mt-2" data-id="element-1175">
            de las mujeres que siguieron el método completo lograron
            reconquistar
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-6 text-center" data-id="element-1176">
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1177">
            <div className="text-3xl font-bold text-[#9C27B0] mb-1" data-id="element-1178">3,427</div>
            <p className="text-gray-600" data-id="element-1179">Mujeres ya usaron el método</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1180">
            <div className="text-3xl font-bold text-[#9C27B0] mb-1" data-id="element-1181">17</div>
            <p className="text-gray-600" data-id="element-1182">Días en promedio para reconquistar</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1183">
            <div className="text-3xl font-bold text-[#9C27B0] mb-1" data-id="element-1184">86%</div>
            <p className="text-gray-600" data-id="element-1185">Continúan juntos después de 1 año</p>
          </div>
        </div>
      </div>
    </div>;
};
export default SuccessStories;